import RestaurantMealsStats from "@/pages/statistics/tabs/RestaurantMealsStats.vue";
import RestaurantGroupMealsStats from "@/pages/statistics/tabs/RestaurantGroupMealsStats.vue";
import RestaurantMoreRestaurantsStats from "@/pages/statistics/tabs/RestaurantMoreRestaurantsStats.vue";
import CompanyDefaultStats from "@/pages/statistics/tabs/CompanyDefaultStats.vue";
import CompanyGroupStats from "@/pages/statistics/tabs/CompanyGroupStats.vue";

const sum = (list, pick) => list.reduce((total, item) => total + (Number(pick(item)) || 0), 0);
const distinct = (list, pick) => new Set(list.map(pick).filter(Boolean)).size;

/**
 * Izvor podataka jednog prikaza statistike. Stari tab (koji učitava podatke za izabrani period i slaže ih u
 * `orders`) se ovde samo nasleđuje; umesto njegovih tabova prikazuje se grafikon izabranog odeljka (`section`), a
 * brojke i stanje učitavanja idu ljusci. Tab se ne ponovo učitava dok se menja odeljak, samo period i prikaz.
 */
const hasStatsFeed = {
  props: {
    section: { type: String, default: "" },
    /** { ključ odeljka: komponenta grafikona } */
    charts: { type: Object, default: () => ({}) },
  },
  computed: {
    chart() {
      return this.charts[this.section] || null;
    },
  },
  watch: {
    statsKpis: {
      handler(kpis) {
        this.$emit("kpis", kpis);
      },
      immediate: true,
    },
    loading: {
      handler(loading) {
        this.$emit("loading", Boolean(loading));
      },
      immediate: true,
    },
  },
  render(h) {
    return this.chart ? h(this.chart, { props: { orders: this.orders } }) : null;
  },
};

const makeFeed = (name, Legacy, kpisOf) => ({
  name,
  extends: Legacy,
  mixins: [hasStatsFeed],
  computed: {
    statsKpis() {
      return kpisOf(this);
    },
  },
});

/** Poručeno / preuzeto po obroku i firmi (Komplet obroci restorana i obična firma): [{ company, qty, taken }] */
const mealsKpis = (companiesLabel) => (vm) => {
  const orders = vm.orders;
  return [
    { key: "ordered", label: vm.$t("ordered"), value: sum(orders, (o) => o.qty), tone: "inverse" },
    { key: "taken", label: vm.$t("taken"), value: sum(orders, (o) => o.taken) },
    { key: "companies", label: vm.$t(companiesLabel), value: distinct(orders, (o) => o.company) },
  ];
};

/** Jela iz grupa: jedan red po jelu i smeni ili po jelu sa brojevima po smenama (shift_1 … shift_4). */
const groupKpis = (vm) => {
  const orders = vm.orders;
  const quantity = (order) =>
    order.shift_1 !== undefined
      ? Number(order.shift_1 || 0) + Number(order.shift_2 || 0) + Number(order.shift_3 || 0) + Number(order.shift_4 || 0)
      : Number(order.quantity || 0);
  return [
    { key: "total", label: vm.$t("report_desktop.total_meals"), value: sum(orders, quantity), tone: "inverse" },
    { key: "meals", label: vm.$t("meals"), value: distinct(orders, (o) => o.meal_name) },
  ];
};

/** Firme koje hrani restoran: [{ name, totals: { total, totalPayed } }] */
const moreKpis = (vm) => {
  const orders = vm.orders;
  return [
    { key: "ordered", label: vm.$t("ordered"), value: sum(orders, (o) => o.totals && o.totals.total), tone: "inverse" },
    { key: "taken", label: vm.$t("taken"), value: sum(orders, (o) => o.totals && o.totals.totalPayed) },
    { key: "companies", label: vm.$t("companies"), value: orders.length },
  ];
};

export const StatsFeedMeals = makeFeed("StatsFeedMeals", RestaurantMealsStats, mealsKpis("companies"));
export const StatsFeedGroupMeals = makeFeed("StatsFeedGroupMeals", RestaurantGroupMealsStats, groupKpis);
export const StatsFeedMoreRestaurants = makeFeed("StatsFeedMoreRestaurants", RestaurantMoreRestaurantsStats, moreKpis);
export const StatsFeedCompanyDefault = makeFeed("StatsFeedCompanyDefault", CompanyDefaultStats, mealsKpis("branches"));
export const StatsFeedCompanyGroup = makeFeed("StatsFeedCompanyGroup", CompanyGroupStats, groupKpis);
